import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import useAuthContext from "../../../context/AuthContext";
import { useEffect, useState } from "react";
import img from "../assets/Image.png";

function HeroSection() {
  const { isAuthenticated } = useAuthContext();

  const texts = [
    "افهم منهجك بدل ما تحفظه",
    "ذاكر كل درس بطريقة سهلة وواضحة",
    "اتدرّب على أسئلة الامتحان باستمرار",
    "اعرف مستواك وطوّر نقاط ضعفك",
  ];

  const [textIndex, setTextIndex] = useState(0);
  const [typedText, setTypedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentText = texts[textIndex];

    const typingSpeed = isDeleting ? 45 : 80;

    const timer = setTimeout(() => {
      if (!isDeleting) {
        setTypedText(currentText.substring(0, typedText.length + 1));

        if (typedText === currentText) {
          setTimeout(() => setIsDeleting(true), 1800);
        }
      } else {
        setTypedText(currentText.substring(0, typedText.length - 1));

        if (typedText === "") {
          setIsDeleting(false);
          setTextIndex((prev) => (prev + 1) % texts.length);
        }
      }
    }, typingSpeed);

    return () => clearTimeout(timer);
  }, [typedText, isDeleting, textIndex]);

  return (
    <section className="hero_section" id="home">
      <Box className="hero_container">
        {/* ================= LEFT SIDE ================= */}
        <div className="intro_side">
          <div className="platform_badge">
            <span className="badge_dot"></span>
            التعليمية PureEng منصة
          </div>
          <div className="teacher_name">
            <h2>Mr. Ahmed Said</h2>
            <span>مع</span>
          </div>
          <span className="span_light">English Teacher • Secondary Stage</span>
          <h1>
            ...الإنجليزي مش حفظ
            <br />
            <span>الإنجليزي فهم وممارسة</span>
          </h1>
          <div className="typing_wrapper">
            <span className="typing_icon">✦</span>

            <p className="typing_text">
              {typedText}
              <span className="cursor">|</span>
            </p>
          </div>
          <p className="hero_description">
            منصة PureEng تساعد طلاب المرحلة الثانوية يفهموا منهج اللغة
            الإنجليزية بطريقة بسيطة ومنظمة، مع تدريبات مستمرة وأسئلة امتحانات
            تساعدك تدخل الامتحان بثقة.
          </p>
          {/* TRUST POINTS */}
          <div className="trust_points">
            <div className="trust_item">
              <span className="trust_icon">✓</span>
              <div>
                <strong>شرح مبسط</strong>
                <small>تفهم قبل ما تحفظ</small>
              </div>
            </div>

            <div className="trust_item">
              <span className="trust_icon">✓</span>
              <div>
                <strong>تدريبات مستمرة</strong>
                <small>أسئلة على كل درس</small>
              </div>
            </div>

            <div className="trust_item">
              <span className="trust_icon">✓</span>
              <div>
                <strong>متابعة مستواك</strong>
                <small>اعرف نقاط ضعفك</small>
              </div>
            </div>
          </div>
          {/* BUTTONS */}
          {/* BUTTONS */}{" "}
          <div className="home_btns">
            {" "}
            <Link
              className="btn primary_btn"
              to={isAuthenticated ? "/lessons" : "/login"}
            >
              {" "}
              {isAuthenticated ? "كمّل مذاكرتك" : "ابدأ مذاكرتك"}{" "}
              <span>→</span>{" "}
            </Link>{" "}
            {isAuthenticated && (
              <Link className="btn secondary_btn" to="/my-lessons">
                {" "}
                شوف الدروس{" "}
              </Link>
            )}{" "}
          </div>
        </div>

        {/* ================= RIGHT SIDE ================= */}
        <div className="teacher_side">
          <div className="image_glow"></div>

          {/* EXPERIENCE CARD */}
          <div className="floating_card experience_card">
            <div className="floating_icon">★</div>

            <div>
              <strong>10+</strong>
              <span>Years Experience</span>
            </div>
          </div>

          {/* STUDENTS CARD */}
          <div className="floating_card students_card">
            <div className="floating_icon">✓</div>

            <div>
              <strong>100%</strong>
              <span>Focus on Understanding</span>
            </div>
          </div>

          <div className="teacher_image_wrapper">
            <div className="image_pattern"></div>

            <div className="img_box">
              <img
                src={img}
                alt="Mr. Ahmed Said"
                loading="eager"
                fetchPriority="high"
                decoding="async"
                onLoad={(e) => e.currentTarget.classList.add("loaded")}
              />
            </div>

            <div className="teacher_info">
              <div>
                <strong>Mr. Ahmed Said</strong>
                <span>English Teacher</span>
              </div>

              <div className="verified_badge">✓</div>
            </div>
          </div>

          <div className="teacher_description">
            <span>Learn with confidence.</span>

            <p>
              Helping students understand English with confidence and clarity.
            </p>
          </div>
        </div>
      </Box>
    </section>
  );
}

export default HeroSection;
